"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.352 3a.7.7 0 0 1 .7.7v7.777l4.075-3.282a.7.7 0 0 1 .878 1.09l-3.18 2.562 3.282 4.01a.7.7 0 1 1-1.083.886l-3.29-4.018-.682.55V16.3a.7.7 0 0 1-1.4 0V3.7a.7.7 0 0 1 .7-.7m7.386 5.04a.7.7 0 0 1 .7.7v.754l.117-.062c.787-.41 1.93-.79 3.226-.54a.7.7 0 1 1-.266 1.375c-.875-.169-1.687.08-2.313.406a5 5 0 0 0-.764.49V16.3a.7.7 0 1 1-1.4 0V8.74a.7.7 0 0 1 .7-.7m.485 3.305",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CurrencySwedishKronaIcon20.js.map